import React, { Component } from 'react';
import {
    Box, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, IconButton, Typography, Tooltip, Collapse,
    Button, TextField,
    InputAdornment,
    TablePagination
} from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Colors } from '../../../Styles/Colors';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { withTranslation } from 'react-i18next';
import {ImagePaths} from '../../../Utility/ImagePaths';
import SearchIcon from '@mui/icons-material/Search';
import { DateTime } from 'luxon';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';

class BillWise extends Component {
    constructor(props) {
        super(props)
        this.state = {
            billList: [],
            selectedIndex: null,
            selectedBillId: null,
            billDetailMap: {},
            isErrorMsg: false,
            isErrorMsgText: '',
            isLoader: false,
            searchKey:'',
            page: 0,
            rowsPerPage: 10,
            FilterDatas: {
                "FromDate":'',
                "ToDate": '',
                "DateIndex": 0,
            },
        }
    }

    componentDidMount() {
        this.getBillList()
    }

    errorMessage = (message) => {
        this.setState({ isErrorMsg: true, isErrorMsgText: message })
    }

    msgClose = () => {
        this.setState({ isErrorMsg: false, isErrorMsgText: '' })
    }

    getBillList = () => {
        try {
            const patientID = this.props.patientDetails?.patient_id
            let from_date = this.state.FilterDatas?.FromDate
            let to_date = this.state.FilterDatas?.ToDate
            RestAPIService.getAll(
                Serviceurls.LAB_PATIENT_BILL_HISTORY +
                `?patient_id=${patientID}&from_date=${from_date}&to_date=${to_date}`
            )
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({ billList: response.data.data })
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getBillDetails = (billId, patientType) => {
        if (this.state.billDetailMap[billId]) return

        try {
            const patientID = this.props.patientDetails?.patient_id
            RestAPIService.getAll(
                Serviceurls.LAB_PATIENT_BILL_HISTORY + `?patient_id=${patientID}&bill_id=${billId}&patient_type=${patientType}`
            ).then((response) => {
                if (response.data.status === 'success') {
                    this.setState((prev) => ({
                        billDetailMap: {
                            ...prev.billDetailMap,
                            [billId]: response.data.data
                        }
                    }))
                }
            }).catch((error) => {
                this.errorMessage(error?.response?.data?.message || error.message)
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getBillTestPrint = (result_item_id, result_summary_id) => {
        try {
            const patientID = this.props.patientDetails?.patient_id
            RestAPIService.getAll(
                Serviceurls.LAB_PATIENT_RESULT_PRINT + `?result_summary_id=${result_summary_id}&result_item_id=${result_item_id}&with_header=${true}&export_type=pdf`
            ).then((response) => {
                if (response) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        //Build a URL from the file
                    const fileURL = URL.createObjectURL(file);
                        //Open the URL on new Window
                    window.open(fileURL);
                }
            }).catch((error) => {
                this.errorMessage(error?.response?.data?.message || error.message)
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    handleRowClick = (index, item) => {
        const isOpen = this.state.selectedIndex === index
        this.setState({ selectedIndex: isOpen ? null : index })
        if (!isOpen) {
            this.getBillDetails(item.bill_id, item.patient_type)
        }
    }

    FilterDate = (From, To, Index) => {
        this.setState({
            FilterDatas: {
                FromDate: From ,
                ToDate: To,
                DateIndex: Index,
            },
            page: 0,
            selectedIndex: null,
        }, () => {
            this.getBillList();
        });
    };

    renderSubTable = (item) => {
        const { t } = this.props
        const details = this.state.billDetailMap[item.bill_id] || []
        return (
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                <Collapse in={true} timeout="auto" unmountOnExit>
                    <Box margin={1}>
                        <Table size="small" sx={{ tableLayout: 'fixed', width: '100%' }}>
                        <TableHead sx={{ '& .MuiTableCell-root': { backgroundColor: Colors.Background, fontWeight: 600, color: Colors.SecondaryText }}}>
                                <TableRow>
                                <TableCell  sx={{ width: '6%' }}>S.No</TableCell>
                                <TableCell  sx={{ width: '30%' }}>Test Name</TableCell>
                                <TableCell  sx={{ width: '28%' }}>Result</TableCell>
                                <TableCell  sx={{ width: '28%' }}>Comments</TableCell>
                                <TableCell  sx={{ width: '8%' }} align='center'>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {details.length > 0 ? details.map((test, subIndex) => (
                                    <TableRow key={subIndex}>
                                        <TableCell>{subIndex + 1}</TableCell>
                                        <TableCell sx={{ wordBreak: 'break-word' }}>
                                            {(test?.test_name || '')?.length > 25 ?
                                                <Tooltip placement='top' title={test?.test_name} arrow>
                                                    <span>{test?.test_name?.slice(0, 25) + '...'}</span>
                                                </Tooltip> : test?.test_name || '-'}
                                        </TableCell>
                                        <TableCell sx={{ wordBreak: 'break-word' }}>
                                            {test?.result?.value !== undefined && test?.result?.value !== null
                                                ? String(test?.result?.value)?.length > 20
                                                    ? <Tooltip placement='top' title={String(test?.result?.value)} arrow>
                                                        <span>{String(test?.result?.value)?.slice(0, 20) + '...'}</span>
                                                    </Tooltip>
                                                    : String(test?.result?.value)
                                                : '-'}
                                        </TableCell>
                                        <TableCell sx={{ wordBreak: 'break-word' }}>
                                            {(test?.result?.comment || '')?.length > 20 ?
                                                <Tooltip placement='top' title={test?.result?.comment} arrow>
                                                    <span>{test?.result?.comment?.slice(0, 20) + '...'}</span>
                                                </Tooltip> : test?.result?.comment || '-'}
                                        </TableCell>
                                        <TableCell align='center'>
                                            <Button
                                                className='eMed_Pat_tbl_two_btn'
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    this.getBillTestPrint(test?.result_item_id, test?.result_summary_id)
                                                }}
                                            >
                                                <Tooltip placement='top' title={'Print'} arrow>
                                                    <img src={ImagePaths.PrintIcons.default} className='eMed_Pat_Bill_img' alt='print' />
                                                </Tooltip>
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )) : (
                                    <TableRow>
                                        <TableCell colSpan={5} align='center'>{t("NoRecordsFound")}</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell>
        )
    }

    render() {
        const { t } = this.props
        const { billList, selectedIndex, searchKey, page, rowsPerPage } = this.state

        const filteredList = billList?.filter((item) => {
            const search = searchKey?.toLowerCase()
            return (
                item?.bill_number?.toLowerCase().includes(search) ||
                item?.bill_date?.toLowerCase().includes(search) ||
                item?.patient_type?.toLowerCase().includes(search) ||
                item?.service_name?.toLowerCase().includes(search)
            )
        })

    // Slice for current page
        const paginatedList = filteredList?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

        return (
            <Box component={'div'} display={'flex'} flexDirection={'column'} height={'100%'}>

                <Box
                    display={'flex'}
                    flexDirection={'row'}
                    justifyContent={'flex-end'}
                    alignItems={'center'}
                    gap={'0.5vw'}
                    sx={{
                        backgroundColor: 'white',
                        borderBottom: '1px solid lightgray',
                        paddingTop: '0.1vw',
                        paddingBottom: '0.1vw'
                    }}
                >
                    <Box sx={{ width: '13vw', minWidth: '160px' }}>
                        <CommonDatePicker
                            FromDate={this.state.FilterDatas.FromDate}
                            ToDate={this.state.FilterDatas.ToDate}
                            DateIndex={this.state.FilterDatas.DateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={false}
                        />
                    </Box>

                    <TextField
                        size='small'
                        placeholder='Search...'
                        value={searchKey}
                        onChange={(e) => this.setState({ searchKey: e.target.value, selectedIndex: null, page: 0 })}
                        sx={{ width: '15vw', minWidth: '180px', marginTop: '-1.4vw' }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position='start'>
                                    <SearchIcon sx={{ fontSize: '1.2vw', color: 'gray' }} />
                                </InputAdornment>
                            ),
                            style: { fontSize: '0.8vw' }
                        }}
                    />
                </Box>
                {/* Table */}
                <TableContainer component={'div'} sx={{ flex: 1, overflow: 'auto', width: '100%' }}>
                    <Table aria-label="bill wise table" stickyHeader>
                   <TableHead sx={{ '& .MuiTableCell-root': { backgroundColor: Colors.Background, fontWeight: 600, color: Colors.SecondaryText }}}>
                            <TableRow>
                                <TableCell sx={{ width: '4%' }} />
                                <TableCell sx={{ width: '6%' }}>S.No</TableCell>
                                <TableCell sx={{ width: '28%' }}>Bill Number</TableCell>
                                <TableCell sx={{ width: '28%' }}>Bill Date & Time</TableCell>
                                <TableCell sx={{ width: '20%' }}>Patient Type</TableCell>
                                <TableCell sx={{ width: '10%' }} align='center'>No. of Tests</TableCell>
                                <TableCell sx={{ width: '8%' }} align='center'>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedList?.length > 0 ? paginatedList.map((item, index) => (
                                <React.Fragment key={index}>
                                    <TableRow
                                        sx={{
                                            backgroundColor: selectedIndex === (page * rowsPerPage + index) ? Colors?.ThemeLightColor : 'white',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => this.handleRowClick(page * rowsPerPage + index, item)}
                                    >
                                        <TableCell>
                                            <IconButton size='small'>
                                                {selectedIndex === (page * rowsPerPage + index)
                                                    ? <KeyboardArrowUpIcon />
                                                    : <KeyboardArrowDownIcon />}
                                            </IconButton>
                                        </TableCell>
                                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                        <TableCell>{item?.bill_number || '-'}</TableCell>
                                        <TableCell>{item?.bill_date || '-'}</TableCell>
                                        <TableCell>{item?.patient_type || '-'}</TableCell>
                                        <TableCell align='center'>{item?.no_of_test ?? '-'}</TableCell>
                                        <TableCell align='center'>
                                            <Button
                                                className='eMed_Pat_tbl_two_btn'
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    this.getBillTestPrint(item?.result_item_id, item?.result_summary_id)
                                                }}
                                            >
                                                <Tooltip placement='top' title={'Print'} arrow>
                                                    <img src={ImagePaths.PrintIcons.default} className='eMed_Pat_Bill_img' alt='print' />
                                                </Tooltip>
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                    {selectedIndex === (page * rowsPerPage + index) && (
                                        <TableRow>
                                            {this.renderSubTable(item)}
                                        </TableRow>
                                    )}
                                </React.Fragment>
                            )) : (
                                <TableRow>
                                    <TableCell colSpan={7} align='center' sx={{ borderBottom: 'none' }}>
                                        {t("NoRecordsFound")}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    component={'div'}
                    rowsPerPageOptions={[10, 20, 30]}
                    count={filteredList?.length || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(e, newPage) => this.setState({ page: newPage, selectedIndex: null })}
                    onRowsPerPageChange={(e) => this.setState({ rowsPerPage: parseInt(e.target.value), page: 0, selectedIndex: null })}
                    sx={{ borderTop: '1px solid lightgray', flexShrink: 0 }}
                />

                {this.state.isErrorMsg &&
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose}
                    />}
            </Box>
        )
    }
}

export default withTranslation()(BillWise)